module.exports = __webpack_public_path__ + "img/logo.c3098b81.svg";